import { styled } from "@mui/material/styles";

export const Container = styled("div")({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  height: "100vh",
  width: "100vw",
  overflow: "hidden",
});

export const Content = styled("div")({
  margin: "var(--space-2xl)",
  maxWidth: "fit-content",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  textAlign: "center",
  color: "var(--color-text-primary)",
  gap: "var(--space-3_5xl)",
});

export const DescriptionTitleContainer = styled("div")({
  fontWeight: "var(--font-weight-bold)",
  padding: "var(--space-xxs)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "clamp(0.6rem, 1.3vw + 0.6rem, 1.2rem)",
});

export const DescriptionSection = styled("section")({
  maxWidth: "37.5rem",
  width: "100%",
  fontSize: "var(--font-size-base)",
  fontWeight: "var(--font-weight-medium)",
});

export const ButtonSection = styled("section")({
  marginTop: "var(--space-3_5xl)",
  width: "100%",
  display: "flex",
  justifyContent: "center",
});

export const HintText = styled("p")({
  maxWidth: "37.5rem",
  width: "100%",
  fontSize: "var(--font-size-sm)",
});

export const Brand = styled("img")({
  position: "absolute",
  bottom: "4rem",
  left: "50%",
  transform: "translateX(-50%)",
});

interface WavyCircleProps {
  position: "top" | "bottom";
}

export const WavyCircle = styled("div")<WavyCircleProps>(({ position }) => ({
  position: "absolute",
  width: "10rem",
  height: "10rem",
  background: "linear-gradient(45deg, var(--color-primary), var(--color-secondary))",
  borderRadius: "30% 70% 70% 30% / 30% 30% 70% 70%",
  boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
  ...(position === "bottom"
    ? { bottom: 0, left: 0, transform: "translate(-50%, 50%)" }
    : { top: 0, right: 0, transform: "translate(50%, -50%)" }),
}));
